import { dayjs } from '@/shared/utils/dayjs';

export type PresetPeriodKey = '7d' | '30d' | '90d';
export type PeriodKey = PresetPeriodKey | 'custom';

export const presetPeriods: PresetPeriodKey[] = ['7d', '30d', '90d'];
export const periodOptions: PeriodKey[] = [...presetPeriods, 'custom'];
export const maxAnalyticsRangeDays = 366;
export const maxAiAnalyticsRangeDays = 90;

const presetRangeDays: Record<PresetPeriodKey, number> = {
  '7d': 7,
  '30d': 30,
  '90d': 90,
};

export const today = () => dayjs().format('YYYY-MM-DD');
export const daysAgo = (days: number) =>
  dayjs().subtract(days, 'day').format('YYYY-MM-DD');

export const getInclusiveRangeDays = (from: string, to: string) => {
  const fromDate = dayjs(from);
  const toDate = dayjs(to);

  if (!fromDate.isValid() || !toDate.isValid() || fromDate.isAfter(toDate)) {
    return null;
  }

  return toDate.diff(fromDate, 'day') + 1;
};

export const getCustomRangeDays = (from: string, to: string) => {
  const days = getInclusiveRangeDays(from, to);
  if (days === null) return null;

  return days > maxAnalyticsRangeDays ? null : days;
};

export const isAiAnalyticsRangeTooWide = (range: {
  from: string;
  to: string;
}) => {
  const days = getInclusiveRangeDays(range.from, range.to);

  return days !== null && days > maxAiAnalyticsRangeDays;
};

export const getPeriodRange = (
  period: PeriodKey,
  customFrom: string,
  customTo: string
) => {
  if (period === 'custom') {
    return getCustomRangeDays(customFrom, customTo) === null
      ? null
      : { from: customFrom, to: customTo };
  }

  return {
    from: daysAgo(presetRangeDays[period] - 1),
    to: today(),
  };
};
